<ion-buttons slot="start">
  <ion-button color="primary" c3Tooltip="Prendi in carico paziente"
              (click)="confermaRifiutaTrasferimento($event, true)">
    <ion-icon size="large" name='checkmark-circle-outline' color="success"></ion-icon>
  </ion-button>
  <ion-button color="danger" c3Tooltip="Rifiuta presa in carico paziente"
              (click)="confermaRifiutaTrasferimento($event, false)">
    <ion-icon size="large" name='close-circle-outline' color="danger"></ion-icon></ion-button>
</ion-buttons>